import { render, staticRenderFns } from "./ShowClipart.vue?vue&type=template&id=54d5bfda&scoped=true"
import script from "./ShowClipart.vue?vue&type=script&lang=js"
export * from "./ShowClipart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d5bfda",
  null
  
)

export default component.exports